import { useState } from "react";
import toast from "react-hot-toast";

import { photoUrl } from "../../config";
import ArrUpIcon from "../ui/ArrUpIcon";
import BookingTariffItem from "./BookingTariffItem";
import BookingFormCard from "./BookingFormCard";
import BookingFormHeader from "./BookingFormHeader";
import BookingFormSteps from "./BookingFormSteps";
import BookingFormCardPrices from "./BookingFormCardPrices";
import BookingDesignVariants from "./designVariants/BookingDesignVariants";
import BookingServiceItem from "./BookingServiceItem";

const prepaid_targets = {
  booking: "от стоимости брони",
  first_day: "от первых суток",
};
const cancel_fees = {
  prepaid: "от размера предоплаты",
  booking: "стоимости брони",
  first_day: "от первых суток",
};

function BookingFormTariffs({
  booking,
  hoteldata,
  bookingData,
  nextStep,
  datein,
  dateout,
  onClose,
}) {
  const [scrolled, setScrolled] = useState(0);
  // const [rulesConfirmed, setRulesConfirmed] = useState(false);
  // const [rulesOpened, setRulesOpened] = useState(false);
  // обработчик скролла, чтобы свернуть подробности
  // обновляет флаг, на который реагирует компонент со списком "все условия"
  const handleScroll = (event) => {
    const { scrollTop } = event.target;
    setScrolled((prev) => prev + 1);
  };

  // const showRules = (e) => {
  //   e.preventDefault();
  //   setRulesOpened((prev) => !prev);
  // };

  const handleNext = () => {
    // if (hoteldata?.rules_of_residence && !rulesConfirmed) {
    //   toast.error("Подтвердите согласие с правилами проживания");
    //   return;
    // }
    if (hoteldata?.separate && !booking.selectedNumber) {
      toast.error("Выберите вариант дизайна");
      return;
    }
    // всё ок, переходим к следующему окну
    nextStep();
  };

  return (
    <div className="bookingWrap formOne" onScroll={handleScroll}>
      <BookingFormHeader
        title={hoteldata.room_name}
        datein={datein}
        dateout={dateout}
        onClose={onClose}
      />
      <div className="bookingForm">
        <div className="bookingCard bookingCard__room mb12">
          {hoteldata.numbers.length == 1 &&
            hoteldata.room_photos?.length == 0 && (
              <BookingDesignVariants
                props={hoteldata}
                set_number={booking.setSelectedNumber}
                selected_number={booking.selectedNumber}
                is_preview={true}
              />
            )}
          <div className="mob_show">
            <h2 className="pl15">{hoteldata.room_name}</h2>
            <p className="tariffFix">По тарифу {hoteldata.tariffs.base.name}</p>
          </div>
          <div className="bookingRoomInfo dfsp">
            <div className="bookingPhoto">
              {hoteldata.room_photos?.length > 0 && (
                <img
                  src={`${photoUrl}/${hoteldata.photo_url}/${bookingData.room}/${hoteldata.room_photos[0]}.jpg`}
                  alt=""
                />
              )}
            </div>
            <div className="bookingRoomInfo__content">
              <span className="tariffFix">
                По тарифу {hoteldata.tariffs.base.name}
              </span>
              <ul className="tariffInfoList firstUp">
                <li>{hoteldata.tariffs.prices[0].food_type}</li>
                <li>
                  {booking.base?.terms_of_payment === "checkin"
                    ? "Оплата при заселении"
                    : `Требуется предоплата ${
                        booking.base?.terms_of_payment_prepaid_sum
                      } ${booking?.terms_of_payment_prepaid_type ? "₽" : "%"} ${
                        prepaid_targets[
                          booking.base?.terms_of_payment_prepaid_target
                        ]
                      }`}
                </li>
                <li>
                  {booking.base?.cancel_reservation_fee === "no"
                    ? "Бесплатная отмена брони"
                    : `Штраф за отмену  ${
                        booking.base?.cancel_reservation_fee_amount
                      } ${
                        booking.base?.cancel_reservation_fee_amount_type
                          ? "₽"
                          : "%"
                      } ${cancel_fees[booking.base?.cancel_reservation_type]}`}
                </li>
              </ul>
            </div>
          </div>
          {hoteldata?.separate && hoteldata.numbers.length > 1 && (
            <BookingDesignVariants
              props={hoteldata}
              set_number={booking.setSelectedNumber}
              selected_number={booking.selectedNumber}
            />
          )}
          <div className="bookingTariffsList">
            {hoteldata?.dop_tariffs?.length > 0 &&
              hoteldata.dop_tariffs.map((def_tariff) => (
                <BookingTariffItem
                  key={`deft${def_tariff.id}`}
                  addTariffHandler={booking.addTariff}
                  tariff={def_tariff}
                  isSelected={
                    !!booking.selectedTariffs?.find(
                      (f) => f.id === def_tariff.id,
                    )
                  }
                />
              ))}
          </div>
          <div className="bookingTariffsList">
            {hoteldata?.additional_tariffs?.length > 0 &&
              hoteldata.additional_tariffs.map((addit_tariff) => (
                <BookingTariffItem
                  key={`addt${addit_tariff.id}`}
                  addTariffHandler={booking.addTariff}
                  isAdditional={true}
                  tariff={addit_tariff}
                  isSelected={
                    booking.selectedAdditionalTariffs?.[0]?.id ===
                    addit_tariff.id
                  }
                />
              ))}
          </div>
          <div className="bookingCard bookingCard__services">
            <div className="bookingCard">
              <h3 className="bookingCard__title mob_show">Услуги</h3>
              {hoteldata?.services?.service?.length > 0 &&
                hoteldata.services.service.map((service) => {
                  // ограничение максимального кол-ва услуг для услуг с датой
                  const s = booking.selectedServices?.find(
                    (f) => f.id === service._id,
                  );
                  let count = 0;
                  if (s) {
                    count = booking.selectedServices?.filter(
                      (f) => f.id === service._id,
                    ).length;
                  }

                  return (
                    <BookingServiceItem
                      key={`serv${service._id}`}
                      {...service}
                      service={service}
                      days={hoteldata.services.days?.[service._id] || []}
                      addServiceHandler={booking.addService}
                      selected={{ ...s, count }}
                      booking={booking}
                      datein={datein}
                      dateout={dateout}
                    />
                  );
                })}
              {hoteldata?.services?.product?.length > 0 &&
                hoteldata.services.product.map((product) => (
                  <BookingServiceItem
                    key={`prod${product._id}`}
                    {...product}
                    service={product}
                    selected={booking.selectedServices?.find(
                      (f) => f.id === product._id,
                    )}
                    addServiceHandler={booking.addService}
                    booking={booking}
                    datein={datein}
                    dateout={dateout}
                  />
                ))}
            </div>
          </div>
        </div>
        <BookingFormCardPrices hoteldata={hoteldata} booking={booking} />
        <BookingFormCard
          booking={booking}
          hoteldata={hoteldata}
          prevStep={onClose}
          nextStep={handleNext}
          datein={datein}
          dateout={dateout}
          onClose={onClose}
          scrolled={scrolled}
        />
      </div>
      <div className="bookingCard__navBtns fix dfsp dfa mob_hide">
        <span className="changeTariff" onClick={onClose}>
          <ArrUpIcon fill="#36549C" />
          назад
        </span>
        <button className="bookingCard__nextBtn" onClick={handleNext}>
          Далее
        </button>
      </div>
      <BookingFormSteps step={1} count={hoteldata.steps_count} />
    </div>
  );
}

export default BookingFormTariffs;
